import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { BaseModal } from '@repo/components/modals';
import styles from './IAPUpgrade.module.scss';
import IAPOptions from '@views/Onboarding/panels/PaymentPanel/IAPOptions';
import { IAPProduct } from '@repo/utils/types';
import { useTheme } from '@repo/themes';

import proImgDark from '@app/img/upgrade/pro_dark.png';
import proImgLight from '@app/img/upgrade/pro_light.png';
import sparklesImgDark from '@app/img/upgrade/sparkles_dark.png';
import sparklesImgLight from '@app/img/upgrade/sparkles_light.jpg';
import { LoaderIcon } from '@repo/icons';
import { useAuthContext } from '@repo/hooks';

export default function IAPUpgradeModal({ closeModal }: { closeModal: () => void }) {
  const { setUserPrimaryProduct } = useAuthContext();
  const [theme] = useTheme();
  const [iAPProducts, setIAPProducts] = useState<IAPProduct[]>([]);

  let proImg = proImgDark;
  let sparklesImg = sparklesImgDark;
  let proImgWidth = 169;

  if (theme === 'light') {
    proImg = proImgLight;
    sparklesImg = sparklesImgLight;
    proImgWidth = 151;
  }

  const onProductPurchased = () => {
    setUserPrimaryProduct('Clay Pro');
    closeModal();
  };

  useEffect(() => {
    window.desktopIntegrations.iap
      .getProducts()
      .then((products) => {
        setIAPProducts(products);
      })
      .catch((err) => {
        console.error('Error fetching IAP products', err);
      });
  }, []);

  return (
    <BaseModal className={cn(styles.modal, styles[theme])} isOpen onRequestClose={closeModal}>
      <img className={styles.sparkles} src={sparklesImg} />
      <div className={styles.content}>
        <img className={styles.proImg} src={proImg} style={{ width: proImgWidth }} />
        <h4>Upgrade to Clay Pro</h4>
        <p>
          Unlock unlimited contacts, 1:1 onboarding,
          <br />
          VIP data import & priority support.
        </p>
        <div className={styles.upgradeOptions}>
          {iAPProducts.length > 0 ? (
            <IAPOptions
              iAPProducts={iAPProducts}
              onProductPurchased={onProductPurchased}
              isUpgradeModal
            />
          ) : (
            <LoaderIcon />
          )}
        </div>
      </div>
    </BaseModal>
  );
}
